<template>
    <div class="cruise-subtitle-wrapper" style="display: none;">
        <div class="midblauw center cruise-subtitle">
            <span
                class="toesturen"
                onclick="$.fancybox('#toesturenModal', {'width':400,'height':450,'autoSize':false});"
                >&nbsp;
                <font-awesome-icon icon="envelope" />
                Vestuur deze cruise</span
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'SendThisCruise',
}
</script>

<style scoped></style>
